// extracted by mini-css-extract-plugin
module.exports = {"HistorySection":"History_HistorySection__a0tnH","HistoryContent":"History_HistoryContent__n6h5n","TimelineElement":"History_TimelineElement__2PBJK"};